// dep: Date.format.escape
var CatalogUtils = {
    aazthe: /^( *a +| *az +| *the +)/i,
    multispace: /  +/g,

    dateTypes: {
        DATE_TIME: 1,
        DATE: 2,
        MONTH: 3,
        YEAR: 4,
        WEEK: 5,
        QUARTER: 6
    },

    dateFormats: {
        hu: {
            formatDateTime: 'Y. F j. H:i',
            formatDate: 'Y. F j.',
            formatMonth: 'Y. F',
            formatYear: 'Y',
            formatWeek: 'Y. V. ' + Date.format.escape('hetén') + ' (F)',
            formatQuarter: 'Y. Q. ' + Date.format.escape('negyedév'),
            formatWeekNumber: 'V. ' + Date.format.escape('hét'),
            formatMonthDay: 'F j.'
        },
        en: {
            formatDateTime: 'j F Y h:i a.',
            formatDate: 'j F Y',
            formatMonth: 'F Y',
            formatYear: 'Y',
            formatWeek: 'Vk ' + Date.format.escape('week of') + ' Y (\\i\\n F)',
            formatQuarter: '\\QQ \\o\\f Y',
            formatWeekNumber: 'Vk ' + Date.format.escape('week'),
            formatMonthDay: 'j F'
        }
    },

    ajaxSetup: function()
    {
        if (location.protocol === 'file:') {
            $.ajaxSetup({
                xhr: function()
                {
                    if ('ActiveXObject' in window) {
                        return new ActiveXObject("Microsoft.XMLHTTP");
                    } else {
                        return new XMLHttpRequest();
                    }
                }
            });
        }
    },

    /**
     * Egy ember számára értelmes szöveget fordít át url-be illeszthető
     * szöveggé, úgy, hogy még valamennyire normálisan nézzen ki.
     *
     * @param {string} str
     * @returns {string}
     */
    urlize: function(str) {
        var charmap = {' ': '-', 'á': 'a', 'é': 'e', 'í': 'i', 'ó': 'o', 'ö': 'o', 'ő': 'o', 'ű': 'u', 'ü': 'u', 'ú': 'u'};
        return str.toString().toLowerCase().replace(/[^a-z0-9]/g, function(chr) {
            return charmap[chr] ? charmap[chr] : '';
        });
    },

    /**
     *  createUrlMap(item, 'tags', 'Tags')
     *
     *  item.tags = ['My Tag', ...];
     *  ->
     *  item.xTagsMap = { 'My Tag': 'my-tag', ... };
     *  item.xTagsRevMap = { 'my-tag': 'My Tag', ... };
     */
    createUrlMap: function(item, base, mapped, cache)
    {
        var xMap = 'x'+mapped+'Map',
            xRevMap = 'x'+mapped+'RevMap',
            items = item[base];

        item[xMap] = {};
        item[xRevMap] = {};

        if (!cache[base]) cache[base] = {urlMap:{},urlRevMap:{},abc:[],count:{_all:0}};
        cache = cache[base];

        var urlTag;
        for (var i = 0, n = items.length; i < n; ++i) {
            if (!cache.urlMap[items[i]]) {
                urlTag = this.urlize(items[i]);

                cache.urlMap[items[i]] = urlTag;
                cache.urlRevMap[urlTag] = items[i];
                cache.count[items[i]] = 0;
                cache.abc.push(items[i]);
            } else {
                urlTag = cache.urlMap[items[i]];
            }

            item[xMap][items[i]] = urlTag;
            item[xRevMap][urlTag] = items[i];
            ++cache.count[items[i]];
            ++cache.count._all;
        }
    },

    createUrlMapMultilang: function(item, base, mapped, cache, langkey)
    {
        var xMap = 'x'+mapped+'Map',
            xRevMap = 'x'+mapped+'RevMap',
            items = item[base][langkey];

        if (!item[xMap]) item[xMap] = {};
        if (!item[xRevMap]) item[xRevMap] = {};

        item[xMap][langkey] = {};
        item[xRevMap][langkey] = {};

        if (!cache[base]) cache[base] = {};
        if (!cache[base][langkey]) cache[base][langkey] = {urlMap:{},urlRevMap:{},abc:[],count:{_all:0}};
        cache = cache[base][langkey];

        var urlTag;
        for (var i = 0, n = items.length; i < n; ++i) {
            if (!cache.urlMap[items[i]]) {
                urlTag = this.urlize(items[i]);

                cache.urlMap[items[i]] = urlTag;
                cache.urlRevMap[urlTag] = items[i];
                cache.count[items[i]] = 0;
                cache.abc.push(items[i]);
            } else {
                urlTag = cache.urlMap[items[i]];
            }

            item[xMap][langkey][items[i]] = urlTag;
            item[xRevMap][langkey][urlTag] = items[i];
            ++cache.count[items[i]];
            ++cache.count._all;
        }
    },

    dateTimeRegex: /^(2[0-9]{3})-(0?[1-9]|1[012])-(0?[1-9]|[12][0-9]|3[01]) (0?[1-9]|1[1-9]|2[0123])(?::([0-6]?[0-9]))?$/,
    //dateRegex: /^(2[0-9]{3})(?:-(0?[1-9]|1[012])(?:-(0?[1-9]|[12][0-9]|3[01]))?)?$/,
    dateRegex: /^(2[0-9]{3})-(0?[1-9]|1[012])-(0?[1-9]|[12][0-9]|3[01])$/,
    monthRegex: /^(2[0-9]{3})-(0?[1-9]|1[012])$/,
    yearRegex: /^(2[0-9]{3})$/,
    weekRegex: /^(2[0-9]{3})-W(0?[1-9]|[1-5][0-9]|5[01234])$/, // 2017-W30
    quarterRegex: /^(2[0-9]{3})-Q([1234])/, // 2017-Q3
    now: new Date(),

    parseDate: function(date) {
        var m, dt;
        if (m = date.match(this.dateTimeRegex)) {

            dt = new Date(
                parseInt(m[1], 10), parseInt(m[2], 10) - 1, parseInt(m[3], 10),
                parseInt(m[4], 10), parseInt(m[5]||0, 10), 0
            );
            dt.dateType = this.dateTypes.DATE_TIME;
            dt.formatText = { hu: this.dateFormats.hu.formatDateTime, en: this.dateFormats.en.formatDateTime };

        } else if (m = date.match(this.dateRegex)) {

            dt = new Date(
                parseInt(m[1], 10), parseInt(m[2], 10) - 1, parseInt(m[3], 10),
                17, 0, 0
            );
            dt.dateType = this.dateTypes.DATE;
            dt.formatText = { hu: this.dateFormats.hu.formatDate, en: this.dateFormats.en.formatDate };

        } else if (m = date.match(this.monthRegex)) {

            dt = new Date(
                parseInt(m[1], 10), parseInt(m[2], 10), 1, // köv hó elseje
                17, 0, 0
            );
            dt.setDate(dt.getDate() - 1); // vissza 1 napot => hónap vége.
            dt.dateType = this.dateTypes.MONTH;
            dt.formatText = { hu: this.dateFormats.hu.formatMonth, en: this.dateFormats.en.formatMonth };

        } else if (m = date.match(this.yearRegex)) {

            dt = new Date(
                parseInt(m[1], 10) + 1, 0, 1, // köv év elseje
                17, 0, 0
            );
            dt.setDate(dt.getDate() - 1); // vissza 1 napot => év vége.

            dt.dateType = this.dateTypes.YEAR;
            dt.formatText = { hu: this.dateFormats.hu.formatYear, en: this.dateFormats.en.formatYear };

        } else if (m = date.match(this.weekRegex)) {

            dt = new Date(
                parseInt(m[1], 10), 0, 1,
                17, 0, 0
            );
            dt.setDate(4 + (parseInt(m[2], 10) - 1) * 7); // január 4 mindig az első héten van, ezzel toljuk el.

            dt.dateType = this.dateTypes.WEEK;
            dt.formatText = { hu: this.dateFormats.hu.formatWeek, en: this.dateFormats.en.formatWeek };

        } else if (m = date.match(this.quarterRegex)) {

            dt = new Date(
                parseInt(m[1], 10), parseInt(m[2], 10) * 3, 1,
                17, 0, 0
            );
            dt.setDate(dt.getDate() - 1); // vissza 1 napot => negyedév vége.

            dt.dateType = this.dateTypes.QUARTER;
            dt.formatText = { hu: this.dateFormats.hu.formatQuarter, en: this.dateFormats.en.formatQuarter };

        } else {
            dt = new Date(1900, 0, 1, 17, 0, 0);
            dt.dateType = this.dateTypes.DATE_TIME;
            dt.formatText = { hu: this.dateFormats.hu.formatDateTime, en: this.dateFormats.en.formatDateTime };
        }
        return dt;
    },

    initDataItem: function(item, init)
    {
        // xReleaseDate
        if (item.rdate) {
            item.xReleaseDate = this.parseDate(item.rdate);
        }

        if (typeof item.rnext !== 'undefined') {
            // előző frissítés
            if (item.rnext > 0) {
                item.xLastReleaseDate = this.parseDate(item.rdates[item.rnext - 1]);
            }
            // következő frissítés
            if (item.rnext < item.rdates.length) {
                item.xReleaseDate = this.parseDate(item.rdates[item.rnext]);
            }
            // ha nincs következő frissítés
            else if (!item.xReleaseDate) { // ebben az esetben item.xLastReleaseDate mindig van!
                item.released = true;
                item.xReleaseDate = item.xLastReleaseDate;
            }

            // minden dátum fordítása
            item.xReleaseDates = [];
            for (var i = 0; i < item.rdates.length; ++i) {
                item.xReleaseDates.push(this.parseDate(item.rdates[i]));
            }

            // minden az aktuális dátum utáni dátum átmásolása
            item.xNextReleaseDates = [];
            for (var i = 0; i < item.xReleaseDates.length; ++i) {
                if (item.xReleaseDates[i] > item.xReleaseDate) {
                    item.xNextReleaseDates.push(item.xReleaseDates[i]);
                }
            }
        }

        // xReleaseMonths
        if (item.xReleaseDate) {
            // init.minDate & maxDate
            if (!init.minDate || item.xReleaseDate < init.minDate) {
                init.minDate = item.xReleaseDate;
            }
            if (!init.maxDate || item.xReleaseDate > init.maxDate) {
                init.maxDate = item.xReleaseDate;
            }

            if (item.released) {
                item.xReleaseMonths = -1;
            } else {
                var months;
                months = (item.xReleaseDate.getFullYear() - this.now.getFullYear()) * 12;
                months -= this.now.getMonth() + 1;
                months += item.xReleaseDate.getMonth() + 1;
                item.xReleaseMonths = Math.max(0, months);
            }
        }

        if (item.title) {
            if (typeof item.title !== 'string') {
                item.xSortTitle = {};
                for (var lang in item.title) {
                    item.xSortTitle[lang] = this.getSortTitle(item.title[lang]);
                }
            } else {
                item.xSortTitle = this.getSortTitle(item.title);
            }
        }

        // xTagsMap, xTagsRevMap
        if (item.tags) {
            if (item.tags instanceof Array) {
                this.createUrlMap(item, 'tags', 'Tags', init);
            } else {
                for (var k in item.tags) {
                    this.createUrlMapMultilang(item, 'tags', 'Tags', init, k);
                }
            }
        }

        // xCatMap, xCatRevMap
        if (item.categories) {
            if (item.categories instanceof Array) {
                this.createUrlMap(item, 'categories', 'Cat', init);
            } else {
                for (var k in item.categories) {
                    this.createUrlMapMultilang(item, 'categories', 'Cat', init, k);
                }
            }
        }

        // xTopicsMap, xTopicsRevMap
        if (item.topics) {
            if (item.topics instanceof Array) {
                this.createUrlMap(item, 'topics', 'Topics', init);
            } else {
                for (var k in item.topics) {
                    this.createUrlMapMultilang(item, 'topics', 'Topics', init, k);
                }
            }
        }
    },

    getSortTitle: function(title) {
        return (title||'zzzzz')
            .replace(this.aazthe, '')
            .replace(this.multispace, ' ')
            .replace('III.', '03')
            .replace('II.', '02')
            .replace('IV.', '04')
            .replace('I\u2013III.', '06')
            .replace('I\u2013II.', '05')
            .replace('I\u2013IV.', '07')
            .replace('I.', '01')
            .replace("01 n", "01 0 n")
            .replace("01 f", "01 1 f")
            .replace(/ \(\+[0-9]{4}\. .vi fel.lvizsg.lt adatok\)/i, '')
            .toLowerCase();
    },

    initData: function(data, init)
    {
        init = init || {};

        // ha az adatok hu/en kulcsokra vannak szétosztva, egyenként inicializájuk őket.
        if (data.hu) {
            for (var lang in data) {
                init[lang] = {};
                this.initData(data[lang], init[lang]);
            }
            return init;
        }

        // innen a hu/en kulcson belül vagyunk ha léteznek.
        init.data = data;

        for (var i = 0, n = data.length; i < n; ++i) {
            this.initDataItem(data[i], init);
        }

        function localeCmp(a,b){return a.localeCompare(b);}

        if (init.tags) {
            if (init.tags.abc) {
                init.tags.abc.sort(localeCmp);
            } else {
                for (var k in init.tags) {
                    init.tags[k].abc.sort(localeCmp);
                }
            }
        }
        if (init.categories) {
            if (init.categories.abc) {
                init.categories.abc.sort(localeCmp);
            } else {
                for (var k in init.categories) {
                    init.categories[k].abc.sort(localeCmp);
                }
            }
        }
        if (init.topics) {
            if (init.topics.abc) {
                init.topics.abc.sort(localeCmp);
            } else {
                for (var k in init.topics) {
                    init.topics[k].abc.sort(localeCmp);
                }
            }
        }
        return init;
    },

    //unused
    initTypes: function(types)
    {
        var init = {};

        init.data = types;

        var item;
        for (var k in types) {
            item = types[k];

            // xTagsMap, xTagsRevMap
            if (item.tags) {
                if (!init.tags) init.tags = {urlMap:{},urlRevMap:{},abc:[],count:{_all:0}};
                this.createUrlMap(item, 'tags', 'Tags', init.tags);
            }

            // xCatMap, xCatRevMap
            if (item.categories) {
                if (!init.categories) init.categories = {urlMap:{},urlRevMap:{},abc:[],count:{_all:0}};
                this.createUrlMap(item, 'categories', 'Cat', init.categories);
            }

            // xTopicsMap, xTopicsRevMap
            if (item.topics) {
                if (!init.topics) init.topics = {urlMap:{},urlRevMap:{},abc:[],count:{_all:0}};
                this.createUrlMap(item, 'topics', 'Topics', init.topics);
            }
        }

        if (init.tags) {
            init.tags.abc.sort();
        }
        if (init.categories) {
            init.categories.abc.sort();
        }
        if (init.topics) {
            init.topics.abc.sort();
        }
        return init;
    },

    loadDataFile: function(filename)
    {
        return $.ajax({
            url: filename,
            dataType: 'json',
            cache: false
        });
    },

    addFilters: function(context, params)
    {
        context.filters = {};
        if (params.megjelent) {
            context.filters.megjelent = params.megjelent;
        }
        if (params.ingyenes) {
            context.filters.ingyenes = params.ingyenes;
        }
        if (params.kategoria) {
            context.filters.kategoria = params.kategoria;
        }
        if (params.rendezes) {
            context.filters.rendezes = params.rendezes;
        }
        if (params.sorrend) {
            context.filters.sorrend = params.sorrend;
        }
    },

    activeItemLoader: null,
    itemAutoLoader_Setup: function()
    {
        var $window = $(window),
            $document = $(document),
            that = this;

        $window.on('scroll', function()
        {
            /*
            console.log('-------------------');
            console.log('doc h: '+$document.height());
            console.log('win h: '+$window.height());
            console.log('scroll top: '+$window.scrollTop());
            console.log('$document.height() - $window.height() - 50: '+ ($document.height() - $window.height() - 50));
            console.log(that.activeItemLoader);
            */

            if (that.activeItemLoader && $document.height() - $window.height() - 100 <= $window.scrollTop()) {
                that.activeItemLoader.load();
            }
        });
    },

    itemAutoLoader: function(container, template, context, items)
    {
        var $container = $(container),
            templating = this.templating,
            that = this,
            loader = {
                offset: 0,
                limit: 200,
                load: function() {
                    context.isopen = $container.hasClass('open-all');
                    for (var i = this.offset, n = Math.min(this.offset + this.limit + 1, items.length); i < n; ++i) {
                        context.item = items[i];
                        $container.append(templating.render(template, context));
                    }
                    this.offset += this.limit;

                    if (this.offset >= items.length - 1) {
                        $('#autoload-progress').hide();
                        that.activeItemLoader = null;
                    }
                }
            };
        this.activeItemLoader = loader;
        return loader;
    }
};